import {WBButton} from '@wandb/weave/common/components/elements/WBButtonNew';
import * as globals from '@wandb/weave/common/css/globals.styles';
import {Icon} from '@wandb/weave/components/Icon';
// eslint-disable-next-line wandb/no-deprecated-imports
import {Container, Header, Input, TextArea} from 'semantic-ui-react';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import teamIcon from '../assets/ic-team.svg';

export const ApplicationsContainer = styled(Container)`
  > h3 {
    margin-bottom: 7px !important;
  }
  > a {
    color: ${globals.gray500};
  }
`;
ApplicationsContainer.displayName = 'S.ApplicationsContainer';

export const Name = styled.h1`
  color: ${globals.black};
  margin-top: calc(${globals.spu} * 1.5);
  margin-bottom: calc(${globals.spu} * 0.5);
  word-break: break-word;
`;
Name.displayName = 'S.Name';

export const Username = styled(Header)`
  display: flex;
  align-items: center;
`;
Username.displayName = 'S.Username';

export const Email = styled(Header)`
  display: flex;
  align-items: center;
`;
Email.displayName = 'S.Email';

export const Bio = styled.div`
  margin-top: calc(${globals.spu} * 1.75);
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
`;
Bio.displayName = 'S.Bio';

export const EditRow = styled.div`
  margin-top: calc(${globals.spu} * 2);
`;
EditRow.displayName = 'S.EditRow';

export const EditLabel = styled.label`
  display: block;
  font-size: calc(${globals.fontSizeStandard} * 0.875);
  font-weight: 600;
  margin-bottom: calc(${globals.spu} * 0.5);
`;
EditLabel.displayName = 'S.EditLabel';

export const EditInput = styled(Input)`
  width: 100%;
  &&&&& input {
    padding: calc(${globals.spu} * 0.75) calc(${globals.spu} * 1.5);
    border-color: ${globals.MOON_250};
  }
`;
EditInput.displayName = 'S.EditInput';

export const EditTextArea = styled(TextArea)`
  &&&&& {
    padding: calc(${globals.spu} * 0.75) calc(${globals.spu} * 1.5);
    width: 100%;
    border: 1px solid #dddddd;
    border-radius: 0.25rem;
    resize: none;
    outline: none;
    font-family: 'Source Sans Pro';
    color: ${globals.textPrimary};

    &:focus {
      border-color: rgba(46, 120, 199, 0.5);
    }
  }
`;
EditTextArea.displayName = 'S.EditTextArea';

export const UserInfoList = styled.div`
  margin: calc(${globals.spu} * 4) 0;
`;
UserInfoList.displayName = 'S.UserInfoList';

export const UserInfoRow = styled.div`
  display: flex;
  align-items: center;
  margin-top: calc(${globals.spu} * 0.625);

  ${EditInput} {
    width: 168px;
  }
`;
UserInfoRow.displayName = 'S.UserInfoRow';

export const UserInfoIcon = styled.img.attrs({
  className: `disable-night-mode-filter-revert`,
})`
  margin-right: calc(${globals.spu} * 1.25);
`;
UserInfoIcon.displayName = 'S.UserInfoIcon';

export const UserInfoValue = styled.div`
  line-height: 33px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;
UserInfoValue.displayName = 'S.UserInfoValue';

export const LaunchIcon = styled(Icon).attrs({name: `open-new-tab`})`
  font-size: calc(${globals.fontSizeStandard} * 1.25);
  margin-left: calc(${globals.spu} * 1);
  position: relative;
  top: calc(${globals.spu} * 0.5);

  color: ${globals.gray400};
  &:hover {
    color: ${globals.TEAL_600};
  }
`;
LaunchIcon.displayName = 'S.LaunchIcon';

export const EditButton = styled(WBButton).attrs({variant: `plain`})`
  &&&&& {
    margin-top: calc(${globals.spu} * 2);
  }
`;
EditButton.displayName = 'S.EditButton';

export const EditActions = styled.div`
  margin-bottom: calc(${globals.spu} * 4);
`;
EditActions.displayName = 'S.EditActions';

export const SaveButton = styled(WBButton).attrs({variant: `confirm`})`
  &&&&& {
    font-size: calc(${globals.fontSizeStandard} * 0.875);
  }
`;
SaveButton.displayName = 'S.SaveButton';

export const CancelButton = styled(WBButton).attrs({variant: `ghost`})`
  &&&&& {
    font-size: calc(${globals.fontSizeStandard} * 0.875);
    margin-left: 8px;
  }
`;
CancelButton.displayName = 'S.CancelButton';

export const TeamIcon = styled.img.attrs({src: teamIcon})``;
TeamIcon.displayName = 'S.TeamIcon';
